import { useEffect, useRef } from "react";
import { api } from "../api/api";
import { isSuperAdmin, isSupport } from "../utils/accessControl";

/**
 * Kundaktivitet: tells the server once a minute that a customer is working in the CMS, and in
 * which part. Only counts while the tab is visible and the person has moved, typed or clicked in
 * the last five minutes, so an open tab overnight is not "time in Notiz". Notiz staff are skipped.
 */
const PING_MS = 60 * 1000;
const IDLE_MS = 5 * 60 * 1000;

export function featureForPath(path) {
  const p = String(path || "");
  if (p === "/") return "overview";
  if (p.startsWith("/screen") || p.startsWith("/setting")) return "screens";
  if (p.startsWith("/playlist")) return "playlists";
  if (p.startsWith("/layout") || p.startsWith("/design-editor")) return "layout";
  if (p.startsWith("/content")) return "content";
  if (p.startsWith("/user")) return "users";
  if (p.startsWith("/integrations")) return "integrations";
  if (p.startsWith("/statistics")) return "statistics";
  if (p.startsWith("/guide")) return "guide";
  return "";
}

export default function useUsagePing(user, pathname) {
  const lastInput = useRef(Date.now());
  const path = useRef(pathname);
  path.current = pathname;

  const tracked = !!user?._id && !isSuperAdmin(user) && !isSupport(user);

  useEffect(() => {
    if (!tracked) return undefined;
    const mark = () => { lastInput.current = Date.now(); };
    const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "wheel"];
    events.forEach((e) => window.addEventListener(e, mark, { passive: true }));
    const timer = setInterval(() => {
      if (document.visibilityState !== "visible") return;
      if (Date.now() - lastInput.current > IDLE_MS) return;
      const feature = featureForPath(path.current);
      if (!feature) return;
      api.post("/usage/ping", { feature }).catch(() => {});
    }, PING_MS);
    return () => {
      clearInterval(timer);
      events.forEach((e) => window.removeEventListener(e, mark));
    };
  }, [tracked]);
}
